import Graphs from '../Graphs';
import { scaleOrdinal } from 'd3-scale';
import { min } from 'd3-array';
import { select, mouse } from 'd3-selection';
import { transition } from 'd3-transition';
import { arc, pie } from 'd3-shape';
import { format } from 'd3-format';
import './PieChart.css';

export default class PieChart extends Graphs {
  renderChart = () => {
    const node = this.node;
    const thisComp = this;
    const padding = 10;
    const radius = (min(this.props.size) / 2) - padding
    global.transition = transition;
    this.setState({className: "PieChart"})

    const colors = scaleOrdinal(this.props.colorScheme);

    const arced = arc()
      .outerRadius(radius - 10)
      .innerRadius(radius * 0.6);

    const pied = pie()
      .sort(null)
      .padAngle(.01)
      .value(d => d);

    const svg = select(node)
      .append("g")
      .attr("transform", `translate(${this.props.size[0] / 2}, ${this.props.size[1] / 2})`);

    const g = svg
      .selectAll('.arc')
      .data(pied(this.props.data.map(item => item.value)))
      .enter()
      .append('g')
      .attr('class', 'arc');

    g
      .append("path")
      .on('mouseover', function () {
        tooltip.style("display", null);
        return select(this)
        .style('fill', 'teal');
      })
      .on('mouseout', function(d, i) {
        tooltip.style("display", "none");
        return select(this).transition("fillColor").style('fill', colors(i))
      })
      .on("mousemove", function(d, i) {
        const xPosition = mouse(this)[0];
        const yPosition = mouse(this)[1];
        tooltip
          .text(`${thisComp.props.data.map(item => item.key)[i]}: ${format(".3s")(d.value)}`);
      })
      .attr("d", arced)
      .style("fill", (d, i) => colors(i))
      .style("opacity", 0)
      .transition("entry")
      .delay((d, i) => (i+1)*300)
      .style("opacity", 1)

    const tooltip = g
      .append("text")
      .attr("text-anchor", "middle")
      .attr("font-size", "0.8em")
      .style("display", "none")

  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/PieChartComponent/PieChart.js